import React from 'react';
import propTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { ReactComponent as NoDocument } from '../../assets/images/NoDocument.svg';

const NoDataFoundComponent = ({
  page,
  rows,
  globalFilter,
  data,
  enablePagination,
  Icon = NoDocument,
}) => {
  let message = null;

  if (data?.length <= 0) {
    message = 'No data present.';
  }

  if (!isEmpty(globalFilter) && (enablePagination ? page : rows).length <= 0) {
    message = 'No result found.';
  }

  return (
    <Box>
      {message && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Icon />
          <Typography variant="subtitle1">{message}</Typography>
        </Box>
      )}
    </Box>
  );
};

NoDataFoundComponent.propTypes = {
  rows: propTypes.oneOfType([propTypes.object]).isRequired,
  page: propTypes.oneOfType([propTypes.object]).isRequired,
  data: propTypes.oneOfType([propTypes.array]).isRequired,
  globalFilter: propTypes.string.isRequired,
  enablePagination: propTypes.bool.isRequired,
  Icon: propTypes.elementType,
};

export default NoDataFoundComponent;
